const getReferralId = (enrollmentId: string, siteCode: string): string => {
  if (!enrollmentId) {
    return '';
  }

  if (!siteCode) {
    return enrollmentId;
  }

  return `${enrollmentId}_${siteCode}`;
};

export default getReferralId;
